import { TFunction } from 'i18next'
import { z } from 'zod'

import { baseContentSchema } from '../shared/schemas'
import { BlockConfig } from '../shared/types'

const pinterestEmbedContentSchema = baseContentSchema.merge(
  z.object({
    websiteUrl: z.string().optional(),
    html: z.string().optional(),
  }),
)

export type PinterestEmbedContentSchema = z.infer<
  typeof pinterestEmbedContentSchema
>

export const pinterestEmbedConfig = ({
  t,
}: {
  t: TFunction<'translation', undefined>
}): BlockConfig => ({
  kind: 'PINTEREST_EMBED',
  minW: 2,
  minH: 2,
  maxW: 4,
  maxH: 16,
  contentKey: 'pinterestEmbedContent',
  schema: pinterestEmbedContentSchema,
  name: t('pinterest_embed'),
  examples: ['https://www.pinterest.com/pin/59883870038250306'],
  description: t('embed_pinterest_posts_to_enrich_your_page_content'),
  searchTags: [
    'pinterest',
    'collections',
    'design',
    'showcase',
    'embed',
    'iframe',
    'html',
    'embed the web',
  ],
})
